module.exports = __webpack_public_path__ + "skins/ZaxonRemake1-0-c7333f1f8fd296f4dd68f9b138d22e5d.wsz";


//////////////////
// WEBPACK FOOTER
// ./skins/ZaxonRemake1-0.wsz
// module id = 137
// module chunks = 5